<template>
	<el-drawer
		v-if="subscription"
		:visible="true"
		@close="close"
		style="border-radius: 0 25px 0 25px; "
		direction="rtl"
		:with-header="false"
		size="80%"
	>
		<div v-if="item" class="drawer-header">
			<div style="margin-top: auto; margin-bottom: auto; margin-left: 10px">
				<span class="title" style="margin-left: 5px">{{ item.name }}</span>
			</div>
			<div style="margin-left: auto; margin-right: 0; margin-top: auto; margin-bottom: auto">
				<md-button class="md-icon-button" @click="close">
					<md-icon style="color: white">close</md-icon>
				</md-button>
			</div>
		</div>
		<div v-if="item" class="drawer-body">
			<div class="container-tab">
				<div :class="{ 'tab-effect': tab != 0 }" class="tab" @click="tab = 0">
					<span :class="{ 'tab-selected': tab == 0 }">{{ $t("details") }}</span>
				</div>
				<div :class="{ 'tab-effect': tab != 1 }" class="tab" @click="tab = 1">
					<span :class="{ 'tab-selected': tab == 1 }">{{ $t("purchases") }}</span>
				</div>
			</div>

			<div v-if="tab == 0" :style="{ height: height + 'px' }" class="page">
				<div style="display:flex">
					<div style="flex:1">
						<h1>{{ $t("details") }}</h1>
					</div>
					<div style="display:flex; justify-content: flex-end; align-items:center; width: 25%">
						<option-button
							:show="true"
							:buttons="buttons"
							:saving="saving"
							@save="handleSave"
							@clear="handleClear"
							@delete="handleDelete"
							@restore="handleRestore"
						/>
					</div>
				</div>

				<subscriptions-form :subscription="item" :editable="true" :source="'edit'" @change="edit = true" />
			</div>

			<div v-if="tab == 1" :style="{ height: height + 'px' }" class="page">
				<payments-table @fetch="getPurchase" />
			</div>

			<div v-if="tab == 0" style="display: flex; width: 100%"></div>
		</div>
		<delete-confirm-modal :show="view_modal" :title="title" :content="content" @close="handleFunction" />
	</el-drawer>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import axios from "axios"
import { getCurrency } from "@/utils/utils"
import OptionButton from "@/modules/_common/button/option-button.vue"
import SubscriptionsForm from "@/modules/datas/subscriptions/subscriptions-components/subscriptions-form.vue"
import PaymentsTable from "../../../users/payments/payments-components/form/payments-table.vue"
import DeleteConfirmModal from "@/modules/_common/modal/delete-confirm-modal.vue"
export default {
	name: "subscriptions-details",
	components: {
		OptionButton,
		SubscriptionsForm,
		DeleteConfirmModal,
		PaymentsTable
	},
	props: ["show"],

	data() {
		return {
			height: window.innerHeight - 265,
			tab: 0,
			edit: false,
			saving: false,
			item: undefined
		}
	},
	computed: {
		...mapGetters({
			deleting: "subscription/deleting",
			restoring: "subscription/restoring",
			subscription: "subscription/subscription",
			purchases: "payment/payments"
		}),
		view_modal: function() {
			return this.deleting || this.restoring
		},
		buttons: function() {
			if (this.edit) return ["save", "clear"]
			var r = []
			if (this.item.deleted_at == undefined) r.push("delete")
			else r.push("restore")

			return r
		},
		title: function() {
			if (this.deleting) return this.$t("deleting-subscriptions-modal-title")
			else if (this.restoring) return this.$t("restoring-subscriptions-modal-title")
		},
		content: function() {
			if (this.deleting) return this.$t("deleting-subscriptions-modal-content")
			else if (this.restoring) return this.$t("restoring-subscriptions-modal-content")
		}
	},

	async created() {
		if (this.subscription == undefined && this.$route.params.id) {
			await this.getSubscriptionById(this.$route.params.id)
		}
		this.item = { ...this.subscription }
	},

	watch: {
		tab: function() {
			if (this.tab == 1) {
				this.getPurchase()
			}
		}
	},
	methods: {
		handleFunction: function(value) {
			if (!value) {
				if (this.deleting) this.doMutate({ element: "deleting", value: false })
				if (this.restoring) this.doMutate({ element: "restoring", value: false })

				return
			} else {
				if (this.deleting) this.handleDelete2()
				else if (this.restoring) this.handleRestore2()
			}
		},
		getCurrency,
		...mapActions({
			doMutate: "subscription/doMutate",
			getSubscriptionById: "subscription/doGetById",
			doGetPurchase: "payment/doGetByFilters",
			doDelete: "subscription/doDelete",
			doRestore: "subscription/doRestore"
		}),

		rowClick: function(item) {
			this.$router.push({ path: "/payments/" + item.id })
		},

		close: function() {
			this.$router.push({ path: "/datas/subscriptions" })
		},

		getPurchase: function(pagination) {
			if (pagination == undefined) pagination = { offset: 0, size: 50 }
			var payload = {
				subscriptions: [this.subscription.id],
				pagination: { offset: pagination.offset, size: pagination.size }
			}
			this.doGetPurchase(payload)
		},

		handleSave: function() {
			var payload = { ...this.item }
			this.saving = true
			payload["duration_month"] = parseInt(payload["duration_month"])
			payload["price"] = parseFloat(payload["price"])
			axios
				.post(process.env.VUE_APP_API_URL + "/api/subscriptions/update", payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					this.$notification("success", this.$t("save-successful"), "", 4500)
					this.edit = false
				})
				.catch(err => {
					this.$processError(this.$t("save-error"), err.response.data.Message)
					console.error(err)
				})
				.finally(_ => {
					this.saving = false
				})
		},

		handleClear: function() {
			this.edit = false
			this.item = { ...this.subscription }
		},

		handleDelete: async function(value) {
			await this.doMutate({ element: "deleting", value: true })
		},
		handleDelete2: function() {
			var array = [this.item]

			this.delete(array)
		},
		async delete(payload) {
			var result = await this.doDelete(payload)
			if (result.status) {
				if (result.value.soft_deleted.length>0){
					this.$notification("error", this.$t("still-active"),  this.$t("still-active-text"), 0)
				}else{
					this.$notification("success", this.$t("deleted-successfully"), "", 4000)
				}

			} else {
				this.$processError(this.$t("delete-error"), result.value)
			}



			this.doMutate({ element: "deleting", value: false })
			this.close()
		},
		handleRestore2: function() {
			var ids = [this.item.id]
			this.restore(ids)
		},

		async restore(payload) {
			var result = await this.doRestore(payload)
			if (result.status) {
				this.$notification("success", this.$t("restored-successfully"), "", 4000)
			} else {
				this.$processError(this.$t("restore-error"), status.msg)
			}

			this.doMutate({ element: "restoring", value: false })
			this.close()
		},

		handleRestore: function(value) {
			this.doMutate({ element: "restoring", value: true })
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/my-drawer";
@import "src/assets/scss/my-form";
@import "src/assets/scss/my-tab";

.page {
	width: 95%;
	margin-left: auto;
	margin-right: auto;
}
</style>
